import { IExtractProps } from "../services/hooks/useContaPagamento";

const tipos = ['MAQ', 'PGE', 'TCC', 'TCD'];

export function groupDataByReference(data: IExtractProps[] | undefined) {
  let newData = data?.map((d) => {
    if (tipos.includes(d.tipo)) {
      const subordinados = data?.filter(
        (data2) =>
          data2.referencia !== null && data2.referencia === d.referencia
      );

      const valorSubs = subordinados?.reduce((a, b) => {
        return a + b.vlMovimento;
      }, 0);

      const types = ['ADM', 'LOC', 'OUT', "ANT"];
      const valorTax = subordinados?.reduce((a, b) => {
        if (types.includes(b.tipo)) return a + b.vlMovimento;

        return a;
      }, 0);

      const valor = subordinados.length ? valorSubs : d.vlMovimento;

      return {
        ...d,
        vlMovimento: valor,
        saldoAcumulado:
          d.tipo === 'MAQ'
            ? d.saldoAcumulado - Math.abs(valorTax)
            : d.saldoAcumulado,
      };
    }
  });

  newData = newData?.filter((n) => n);

  return newData;
}
